import { useEffect, useRef, useState } from 'react';

export function useToast() {
  const [msg, setMsg] = useState<string | null>(null);
  const timer = useRef<number | null>(null);

  function show(m: string) {
    setMsg(m);
    if (timer.current) window.clearTimeout(timer.current);
    timer.current = window.setTimeout(() => setMsg(null), 1400);
  }

  useEffect(() => {
    return () => { if (timer.current) window.clearTimeout(timer.current); };
  }, []);

  return { msg, show };
}
